import axios from 'axios'
import store from '../vuex/store'

class ApiSingleton {
  constructor () {
    if (!ApiSingleton.instance) {
      var api = axios.create({
        baseURL: process.env.API_URL
      })

      if (store.getters.isLoggedIn) {
        api.defaults.headers.common['Authorization'] = 'Token ' + store.state.user.authToken
      }

      api.interceptors.response.use(response => {
        return response
      }, error => {
        if (error.response.status === 401) {
          store._actions.logout[0]()
          window.bentoApp.$modal.open('login', {next: window.bentoApp.$route.path, disableclose: true})
        }
        return Promise.reject(error)
      })
      ApiSingleton.instance = api
    }

    return ApiSingleton.instance
  }
}

const instance = new ApiSingleton()
Object.freeze(instance)

export default instance



// WEBPACK FOOTER //
// ./src/api/index.js